import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { uploadReset } from "../../redux/Actions/SingleUserActions";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import UserStatus from "../../components/Certification/UserStatus";
import {
  getDocs,
  getRequiredDocs,
  getUserStatus,
} from "../../redux/Actions/GetDocsActions";
import { useHistory } from "react-router-dom";
import Alert from "../../utils/Alert";
import POSRequirement from "../Certification/POSRequirement";
import { renewPosDocs } from "../../redux/Actions/PosActions";
import DocsUpload from "../Certification/DocsUpload";
import checkDocs from "../../utils/Functions/CheckCategory";
import UpdateArray from "../../utils/Functions/UpdateArray";
import Spinner from "react-spinner-material";
import assign from "../../utils/Functions/AssignObj";
import Storage from "../../utils/storage";
import { PropTypes } from "prop-types";
import { getCertificationAmount } from "../../redux/Actions/GetDocsActions";

const DeviceUploadRenewal = (props) => {
  const {
    getDocsList,
    getStatus,
    dashboardData,
    isGetting,
    isUploading,
    uploadSuccess,
    uploadDocs,
    uploadReset,
    docs,
    isFetching,
    getStatusSuccess,
    requiredDocs,
    getRequiredDocs,
    isFetchingRequiredDocs,
    getRequiredDocsSuccess,
    getCertificationAmount
  } = props;
  const history = useHistory();
  const singlePosApp = props.location.state;
  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let categoryChoice = user && user.category_id;

  const [state, setState] = useState({
    openModal: false,
    fileResult: {},
    allResult: [],
    errorMessage: "",
    items: [],
    document: [],
    inputValue: "",
  });

  useEffect(
    () => {
      uploadReset();
      const type = "device";
      getRequiredDocs(type);
      getStatus();
    },
    // eslint-disable-next-line
    [uploadReset, getRequiredDocs, getStatus]
  );

  const appStatus =
    dashboardData && dashboardData[1] && dashboardData[1].pos_application;
  const userAppStatus2 = appStatus && appStatus[0] && appStatus[0].status;
  const userAppStatus =
    appStatus && appStatus[0] && appStatus[0].nibss_super_admin_status;
  const userAppId =
    singlePosApp && singlePosApp.application && singlePosApp.application.id;
  const appName =
    singlePosApp &&
    singlePosApp.application &&
    singlePosApp.application.application_name;
  const appVersion =
    singlePosApp &&
    singlePosApp.application &&
    singlePosApp.application.application_version;
  const userCompanyId = appStatus && appStatus[0] && appStatus[0].company_id;

  useEffect(() => {
    if (getStatusSuccess) {
      const type = "certification";
      getDocsList(type);
    }
  },
  // eslint-disable-next-line
  [getStatusSuccess, getDocsList]);

  const categoryDocs =
    requiredDocs &&
    requiredDocs[categoryChoice] &&
    requiredDocs[categoryChoice].documents;

  const uploadedDocs = docs && docs[0] && docs[0].documents;
  const filteredUploadedDocs =
    uploadedDocs &&
    uploadedDocs.filter(
      (item) =>
        item.id === 1 ||
        item.id === 21 ||
        item.id === 22 ||
        item.id === 23 ||
        item.id === 24 ||
        item.id === 25 ||
        item.id === 26 ||
        item.id === 38 ||
        item.id === 39
    );
  const docsLength = filteredUploadedDocs && filteredUploadedDocs.length > 0;

  checkDocs(categoryDocs, filteredUploadedDocs);

  function handleDataFetch(fileResult) {
    if (filteredUploadedDocs && filteredUploadedDocs.length > 0) {
      let allResult = uploadedDocs;
      setState({
        allResult,
      });
      UpdateArray(allResult, fileResult);
      setState({ allResult });
    } else {
      let allResult = [...state.allResult];
      UpdateArray(allResult, fileResult);
      setState({ allResult });
    }
  }

  const handleRemoval = (fileResult) => {
    state.allResult &&
      state.allResult.splice(
        state.allResult.findIndex((item) => item.id === fileResult.id),
        1
      );
    setState(JSON.parse(JSON.stringify(state)));
    return state.allResult
  };

  const uploadDeviceDocs = () => {
    if (
      filteredUploadedDocs &&
      filteredUploadedDocs.length === 7 &&
      state.allResult.length === 0
    ) {
      uploadDeviceDocs1();
    } else {
      uploadDeviceDocs2();
    }
  };

  const uploadDeviceDocs1 = () => {
    let allFiles = [];
    let data =
      uploadedDocs &&
      uploadedDocs.filter(
        (item) =>
          item.id === 1 ||
          item.id === 21 ||
          item.id === 22 ||
          item.id === 23 ||
          item.id === 24 ||
          item.id === 25 ||
          item.id === 26 ||
          item.id === 38 ||
          item.id === 39
      );
    assign(data, allFiles);
    const files = {
      application_id: userAppId && userAppId.toString(),
      company_id: userCompanyId && userCompanyId.toString(),
      type: "device",
      document: allFiles,
      renewal_doc: {
        application_name: appName,
        application_version: appVersion,
      },
    };
    uploadDocs(files);
  };

  const uploadDeviceDocs2 = () => {
    let allFiles = [];
    const data =
      state.allResult &&
      state.allResult.filter(
        (item) =>
          item.id === 1 ||
          item.id === 21 ||
          item.id === 22 ||
          item.id === 23 ||
          item.id === 24 ||
          item.id === 25 ||
          item.id === 26 ||
          item.id === 38 ||
          item.id === 39
      );
    assign(data, allFiles);
    const files = {
      application_id: userAppId && userAppId.toString(),
      company_id: userCompanyId && userCompanyId.toString(),
      type: "device",
      document: allFiles,
      renewal_doc: {
        application_name: appName,
        application_version: appVersion,
      },
    };
    uploadDocs(files);
  };

  const disable =
    state.allResult &&
    state.allResult.filter(
      (item) =>
        item.id === 21 ||
        item.id === 22 ||
        item.id === 23 ||
        item.id === 24 ||
        item.id === 25 ||
        item.id === 26 ||
        item.id === 38 ||
        item.id === 39
    ).length < 8;

  const disable2 =
    state.allResult &&
    state.allResult.filter(
      (item) =>
        item.id === 1 ||
        item.id === 21 ||
        item.id === 22 ||
        item.id === 23 ||
        item.id === 24 ||
        item.id === 25 ||
        item.id === 26 ||
        item.id === 38 ||
        item.id === 39
    ).length < 9;

  useEffect(
    () => {
      if (uploadSuccess) {
        state.errorMessage = "";
        Alert(true, "success", "Success message", "Upload successful.");
        history.push({
          pathname: "/payment",
          state: {
            id: userAppId,
            type: "device",
            amount_id: 2,
          },
        });
        getCertificationAmount(2, userAppId)
      }
    },
    // eslint-disable-next-line
    [uploadSuccess]
  );

  return (
    <div className="container">
      <UserNav />
      <Sidebar />

      <main className="container-body">
        <UserStatus
          userAppStatus={userAppStatus}
          userAppStatus2={userAppStatus2}
          appStatus={appStatus}
        />

        <div className="upload-flex">
          <div className="upload-title">
            <h2>POS Device Certification Documents</h2>
            <p>
              The documents we ask for are based on your certification selection
            </p>
            <p>
              (Only pdf, png, jpeg and jpg formats are allowed with a max file
              size of 5MB)
            </p>
          </div>

          <POSRequirement type="device" />
        </div>

        {isGetting || isFetchingRequiredDocs ? (
          <div className="center-spinner2">
            <br />
            <Spinner
              size={120}
              color={"#047558"}
              spinnerwidth={5}
              visible={true}
            />
          </div>
        ) : (
            getRequiredDocsSuccess && (
              <DocsUpload
                categoryDocs={categoryDocs}
                upload={uploadDeviceDocs}
                disabled={
                  docsLength ? disable === true : disable2 === true || isUploading
                }
                isUploading={isUploading}
                handleDataFetch={handleDataFetch}
                handleRemoval={handleRemoval}
                isFetching={isFetching}
                text={"PROCEED TO PAYMENT"}
              />
            )
          )}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isUploading: state.pos.isRenewingPos,
    uploadSuccess: state.pos.renewPosSuccess,
    uploadedDoc: state.pos.renewal,
    docs: state.docs.docs,
    dashboardData: state.docs.status,
    isFetching: state.docs.isFetching,
    isGetting: state.docs.isGetting,
    getStatusSuccess: state.docs.getStatusSuccess,
    isFetchingRequiredDocs: state.docs.isGettingDocs,
    requiredDocs: state.docs.requiredDocs,
    getRequiredDocsSuccess: state.docs.getRequiredDocsSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  uploadDocs: (payload) => dispatch(renewPosDocs(payload)),
  getDocsList: (type) => dispatch(getDocs(type)),
  getStatus: () => dispatch(getUserStatus()),
  uploadReset: () => dispatch(uploadReset()),
  getRequiredDocs: (type) => dispatch(getRequiredDocs(type)),
  getCertificationAmount: (type, appId)=> dispatch(getCertificationAmount(type, appId)),
});

DeviceUploadRenewal.propTypes = {
  dashboardData: PropTypes.array,
  docs: PropTypes.array,
  getDocsList: PropTypes.func,
  getRequiredDocs: PropTypes.func,
  getRequiredDocsSuccess: PropTypes.bool,
  getStatus: PropTypes.func,
  getStatusSuccess: PropTypes.bool,
  isFetching: PropTypes.bool,
  isFetchingRequiredDocs: PropTypes.bool,
  isGetting: PropTypes.bool,
  isUploading: PropTypes.bool,
  location: PropTypes.shape({
    state: PropTypes.shape({
      application: PropTypes.shape({
        application_name: PropTypes.string,
        application_version: PropTypes.string,
        id: PropTypes.number,
      }),
    }),
  }),
  requiredDocs: PropTypes.object,
  uploadDocs: PropTypes.func,
  uploadReset: PropTypes.func,
  uploadSuccess: PropTypes.bool,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceUploadRenewal);
